import React, { forwardRef } from "react";
import SnMemoBox from "@shared/components/SnMemoBox";

interface popupProps {
  txtItemSpec: any;
}

const SN_PRD_RUN_REG_001_CHEM_POP_003 = forwardRef(
  ({ txtItemSpec }: popupProps, popupRef: React.Ref<any>) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "10px",
        }}
      >
        <SnMemoBox
          defaultValue={txtItemSpec}
          isReadOnly={true}
          isEditable={false}
        />
      </div>
    );
  }
);

export default SN_PRD_RUN_REG_001_CHEM_POP_003;
